import ImageProxy from '@next-image-proxy';

import { CommonStory } from '@shared/api/types/story';
import { useBreakpoint } from '@shared/hooks/useBreakpoint';

export default function StoryHeadBanner({
  story,
  storyTitle,
}: {
  story: CommonStory;
  storyTitle?: string;
}) {
  const isLargeTablet = useBreakpoint('lg', 'max');
  const isSmallTablet = useBreakpoint('md', 'max');
  const isMobile = useBreakpoint('sm', 'max');
  const { bannerUrl, bannerDeskUrl, bannerLargeTabletUrl, bannerSmallTabletUrl, bannerMobileUrl } =
    story?.content ?? {};

  const getMainBannerUrl = () => {
    if (bannerDeskUrl && !isLargeTablet) {
      return bannerDeskUrl;
    }

    if (bannerLargeTabletUrl && isLargeTablet && !isSmallTablet) {
      return bannerLargeTabletUrl;
    }

    if (bannerSmallTabletUrl && isSmallTablet && !isMobile) {
      return bannerSmallTabletUrl;
    }

    if (bannerMobileUrl && isMobile) {
      return bannerMobileUrl;
    }

    return bannerUrl;
  };

  const mainBannerUrl = getMainBannerUrl();

  return (
    <ImageProxy
      className="stories-banner"
      src={mainBannerUrl}
      alt={`${storyTitle} banner` || 'Magic Store story banner'}
      fill
      quality={90}
    />
  );
}
